import {defineMessages} from 'react-intl';

export const INTL_MESSAGES = defineMessages({
  SELECT_DAY: {
    id: 'ui.label.input.PLEASE_SELECT_DAY',
    defaultMessage: 'Please select',
    description: 'Label asking the user to select a day.',
  },
  SELECT_MONTH: {
    id: 'ui.label.input.PLEASE_SELECT_MONTH',
    defaultMessage: 'Please select',
    description: 'Label asking the user to select a month.',
  },
  SELECT_YEAR: {
    id: 'ui.label.input.PLEASE_SELECT_YEAR',
    defaultMessage: 'Please select',
    description: 'Label asking the user to select a year.',
  },
  JANUARY: {
    id: 'ui.label.input.AGE_GATE_JANUARY',
    defaultMessage: 'January',
    description: 'Name of the month appearing on an age verification form.',
  },
  FEBRUARY: {
    id: 'ui.label.input.AGE_GATE_FEBRUARY',
    defaultMessage: 'February',
    description: 'Name of the month appearing on an age verification form.',
  },
  MARCH: {
    id: 'ui.label.input.AGE_GATE_MARCH',
    defaultMessage: 'March',
    description: 'Name of the month appearing on an age verification form.',
  },
  APRIL: {
    id: 'ui.label.input.AGE_GATE_APRIL',
    defaultMessage: 'April',
    description: 'Name of the month appearing on an age verification form.',
  },
  MAY: {
    id: 'ui.label.input.AGE_GATE_MAY',
    defaultMessage: 'May',
    description: 'Name of the month appearing on an age verification form.',
  },
  JUNE: {
    id: 'ui.label.input.AGE_GATE_JUNE',
    defaultMessage: 'June',
    description: 'Name of the month appearing on an age verification form.',
  },
  JULY: {
    id: 'ui.label.input.AGE_GATE_JULY',
    defaultMessage: 'July',
    description: 'Name of the month appearing on an age verification form.',
  },
  AUGUST: {
    id: 'ui.label.input.AGE_GATE_AUGUST',
    defaultMessage: 'August',
    description: 'Name of the month appearing on an age verification form.',
  },
  SEPTEMBER: {
    id: 'ui.label.input.AGE_GATE_SEPTEMBER',
    defaultMessage: 'September',
    description: 'Name of the month appearing on an age verification form.',
  },
  OCTOBER: {
    id: 'ui.label.input.AGE_GATE_OCTOBER',
    defaultMessage: 'October',
    description: 'Name of the month appearing on an age verification form.',
  },
  NOVEMBER: {
    id: 'ui.label.input.AGE_GATE_NOVEMBER',
    defaultMessage: 'November',
    description: 'Name of the month appearing on an age verification form.',
  },
  DECEMBER: {
    id: 'ui.label.input.AGE_GATE_DECEMBER',
    defaultMessage: 'December',
    description: 'Name of the month appearing on an age verification form.',
  },
  YEAR_PLACEHOLDER: {
    id: 'ui.label.input.AGE_GATE_YEAR_PLACEHOLDER',
    defaultMessage: 'Year',
    description: 'Placeholder for the year selection box on the age verification form.',
  },
});



// WEBPACK FOOTER //
// ./lib/rlink-agegate/messages/constants.jsx